import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { TextSkeleton } from "../ChatUI/TextSkeleton";

type Props = {
	text: string;
	isLoading: boolean;
	isDisabled: boolean;
};

const PlayerTime = ({ text, isLoading, isDisabled }: Props) => {
	const theme = useAppTheme();

	if (isLoading) {
		return (
			<Box width={84}>
				<TextSkeleton height={16} />
			</Box>
		);
	}

	return (
		<Text
			variant="labelLarge"
			numberOfLines={1}
			style={{
				minWidth: 84,
				textAlign: "right",
				flexShrink: 0,
				fontWeight: "500",
				color: isDisabled
					? theme.colors.onSurfaceVariant
					: theme.colors.onSecondaryContainer,
			}}
		>
			{text}
		</Text>
	);
};

export default PlayerTime;
